import { useEffect } from "react";

export const Seo = ({ title, description }) => {
  useEffect(() => {
    if (title) document.title = `${title} — Jennae Michelle Holdings`;
    if (description) {
      let m = document.querySelector('meta[name="description"]');
      if (!m) {
        m = document.createElement("meta");
        m.setAttribute("name", "description");
        document.head.appendChild(m);
      }
      m.setAttribute("content", description);
    }
  }, [title, description]);
  return null;
};
